module.exports = __webpack_public_path__ + "img/650-e8b680.png";